import { get } from "lodash";

export const getConfig = <T = string | null>(key: string, fallback = null): T =>
  typeof window !== "undefined" ? get(window.eaveEnv, key, fallback) : fallback;

export const isDevelopment = () => getConfig("env") === "development";
export const isIntegration = () => getConfig("env") === "integration";
export const isHotfix = () => getConfig("env") === "hotfix";
export const isStaging = () => getConfig("env") === "staging" || isHotfix();
export const isProduction = () => getConfig("env") === "production";

export function getFileDownloadBaseURL(fileKey, downloadAsFileName = null) {
  let downloadURL = `/files/${fileKey}`;
  if (downloadAsFileName) {
    downloadURL += `?download_as=${encodeURIComponent(downloadAsFileName)}`;
  }
  return downloadURL;
}

/** Will grab the corresponding featureFlag key.
 * To modify feature flags, see:
 *   - packages/operator/public/eave.html
 *   - packages/borrower/public/eave.html
 *   - packages/marketing/src/utils/index.ts
 * @param  {string} flag
 * @returns boolean
 */
export function featureFlag(flag: string): boolean {
  return getConfig(`featureFlags.${flag}`, false);
}
